export default __webpack_public_path__ + "static/media/onda_fondo.5f9cc442.png";